angular.module('autoremind.templates')
    .directive('imageUpload', ['FileUploader', '$compile', 'templateService', '$parse', '$interval', '$location', 'accountService', '$timeout',
    function (FileUploader, $compile, templateService, $parse, $interval, $location, accountService, $timeout) {
        return {
            restrict: 'A',
            scope: true,
            multiElement: true,
            require: 'ngModel',
            priority: 1,
            link: function (scope, elem, attr, ngModel) {
                scope.isForAdmin = true;
                // Temporarily disable upload in Communications page
                if ($location.path().indexOf('communication') !== (-1)) {
                    scope.isForAdmin = false;
                }
                scope.viewModel = {
                    file: null,
                    modelName: attr.ngModel,
                    defaultFile: null
                };
                scope.element = elem;
                scope.attr = attr;
                if ($parse(attr.ngModel)(scope) === '') {
                    var imgKey = attr.ngModel.replace("template.", "");
                    if (angular.isDefined(templateService.previewModel.inFile[imgKey])) {
                        if (angular.isDefined(scope.setImageSrc)) {
                            scope.setImageSrc(templateService.previewModel.inFile[imgKey]);
                            // scope.element.attr('src', templateService.previewModel.inFile[imgKey] + '?' + new Date().getTime() )
                        }
                    }
                }
                console.log($parse(attr.ngModel)(scope));
                scope.updateImageModel = function (url) {
                    console.log(url);
                    $timeout(function () {
                        ngModel.$setViewValue(url);
                    });
                };
                scope.setImageSrc = function (src) {
                    var setSrc = function (url) {
                        var random = (new Date()).getTime();
                        scope.element.attr('src', url + '?n=' + random);
                    };
                    var dataToPreprocess = {};
                    var imgKey = attr.ngModel.replace("template.", "");
                    dataToPreprocess[imgKey] = src;
                    templateService.preprocessModel('email', { model: { template: dataToPreprocess } })
                        .then(function (result) {
                        if (angular.isDefined(result.variables[imgKey])) {
                            setSrc(result.variables[imgKey]);
                            return;
                        }
                        setSrc(src);
                    }, function () {
                        setSrc(src);
                    });
                };
                scope.$watch(function () {
                    return $parse(attr.ngModel)(scope);
                }, function (newVal, oldVal) {
                    if (newVal === '') {
                        return;
                    }
                    scope.setImageSrc(newVal);
                });
                scope.adminUploader = function (item) {
                    scope.viewModel.file = item;
                    scope.viewModel.file.alias = (new Date().getTime() + 'R' + Math.floor(Math.random() * 9999) + '.jpg');
                    templateService.selectUploadImagesDialog({}, scope.viewModel, item);
                    return true;
                };
                scope.fileUploadProgress = 0;
                scope.userUploader = function (file) {
                    if (!file) {
                        return;
                    }
                    var fileModel = {};
                    scope.fileUploadProgress = 0;
                    var fileType = file.type;
                    var alias = new Date().getTime() + 'R' + Math.floor(Math.random() * 9999) + '.' + (fileType.substr(fileType.lastIndexOf('/') + 1));
                    fileModel.file = file;
                    fileModel.file.alias = alias;
                    fileModel.tmpFileName = alias;
                    scope.createFileNameAndPath(fileModel);
                    templateService.uploadTemplateFile(fileModel.file)
                        .progress(function (evt) {
                        scope.fileUploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                    })
                        .success(function (response, status, headers, config) {
                        scope.fileUploadProgress = 0;
                        templateService.useImages({ useImagesList: new Array(fileModel) })
                            .then(function () {
                            scope.updateImageModel(fileModel.src);
                        });
                    })
                        .error(function (err) {
                        scope.fileUploadProgress = 0;
                    });
                };
                scope.createFileNameAndPath = function (model) {
                    var baseImageUrl = 'https://images.autoremind.us/';
                    var imageName = angular.copy(model.file.name);
                    if (imageName.lastIndexOf('/') > 0) {
                        imageName = imageName.substr(imageName.lastIndexOf('/') + 1, imageName.length);
                    }
                    imageName = imageName.toLowerCase();
                    imageName = imageName.replace(/\s{1,}/g, "-");
                    var createdUrl = imageName.replace(/\/{2,}/g, '/');
                    // model.src = baseImageUrl + (scope.getUserFolder() + encodeURIComponent(createdUrl)).replace(/\/{2,}/g, '/');
                    console.log('accountService', accountService);
                    model.src = baseImageUrl + (accountService.currentUser.userId + '/' + createdUrl).replace(/\/{2,}/g, '/');
                    model.fileName = (accountService.currentUser.userId + '/' + imageName).replace(/\/{2,}/g, '/');
                };
                var uploader = scope.uploader = new FileUploader({
                    filters: [{
                            fn: scope.isForAdmin ? scope.adminUploader : scope.userUploader
                        }]
                });
                scope.fileOver = function () {
                    console.log('fileOver');
                };
                var directiveHtml = '';
                if (scope.isForAdmin) {
                    directiveHtml = '<div nv-file-over nv-file-drop="" ng-if="uploader" uploader="uploader" class="overlay_image" ng-click="openUploadImageDialog()" nv-file-over nv-file-drop="" uploader="uploader">' +
                        '<span class="glyphicon glyphicon-upload" aria-hidden="true" uib-tooltip="Upload/select image"></span>' +
                        '</div>';
                }
                else {
                    // For some reason it does not work selecting a DOM element with period in the name
                    var inputId = 'imageUploadInput' + attr.ngModel.replace('template.', '');
                    directiveHtml = '' +
                        '<input id="' + inputId + '" type="file" style="display: none" ngf-select="userUploader($files[0])" importfile="viewModel.defaultFile" multiple="multiple" accept="image/*">' +
                        '<div nv-file-over nv-file-drop="" ng-if="uploader" uploader="uploader" class="overlay_image" ng-click="justUploadImage(\'#' + inputId + '\')" nv-file-over nv-file-drop="" uploader="uploader">' +
                        '   <span class="glyphicon glyphicon-upload" aria-hidden="true" uib-tooltip="Upload image"></span>' +
                        '</div>';
                }
                scope.add = function () {
                    if (angular.isDefined(attr.imageList)) {
                        elem.removeAttr('image-list');
                    }
                    elem.removeAttr('image-upload');
                    var parent = elem.parent();
                    parent.append('<div class="imageContainer"></div>');
                    var imageContainer = parent.find('.imageContainer');
                    imageContainer.append(elem);
                    imageContainer.append(directiveHtml);
                    $compile(imageContainer)(scope);
                    $compile(elem)(scope);
                }();
                scope.justUploadImage = function (imageInputElementName) {
                    // This will trigger opening the file browser to select an image to upload
                    angular.element(imageInputElementName).click();
                };
                scope.openUploadImageDialog = function () {
                    templateService.selectUploadImagesDialog({}, scope.viewModel)
                        .then(function (result) {
                        console.log('selectUploadImagesDialog', result);
                    }, function (error) {
                        console.log('selectUploadImagesDialog', error);
                    });
                };
            }
        };
    }]);
//# sourceMappingURL=image-upload.directive.js.map